import { render, staticRenderFns } from "./kcon.vue?vue&type=template&id=bb34d150&scoped=true"
import script from "./kcon.vue?vue&type=script&lang=js"
export * from "./kcon.vue?vue&type=script&lang=js"
import style0 from "./kcon.vue?vue&type=style&index=0&id=bb34d150&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb34d150",
  null
  
)

export default component.exports